/** Every time on this page (registration close, schedule milestones) is entered and stored as
 *  Eastern wall-clock time; the backend (eventPage.cfc's isoOrEmpty()) sends it back as a real
 *  tz-aware ISO 8601 string with the correct Eastern UTC offset for that date (DST-aware). So
 *  the value must always be rendered in the America/New_York zone explicitly - letting these
 *  helpers fall back to the viewer's own local zone shifts the clock time (and can even flip
 *  the calendar date) for any viewer not physically on Eastern time. */
export const EASTERN = 'America/New_York'

/** Lucee's default JSON date serialization isn't guaranteed here (no running server to check
 *  against), so every date is parsed defensively - an unparseable/empty value renders as the
 *  fallback rather than "Invalid Date" or a thrown error. */
export function formatDate(value: string | undefined | null, opts: Intl.DateTimeFormatOptions = { month: 'short', day: 'numeric' }): string {
  if (!value) return ''
  const d = new Date(value)
  if (Number.isNaN(d.getTime())) return ''
  return d.toLocaleDateString(undefined, { ...opts, timeZone: EASTERN })
}

export function formatDateTime(value: string | undefined | null): string {
  if (!value) return ''
  const d = new Date(value)
  if (Number.isNaN(d.getTime())) return ''
  return `${d.toLocaleString(undefined, { month: 'short', day: 'numeric', hour: 'numeric', minute: '2-digit', timeZone: EASTERN })} ET`
}

export function formatMoney(value: number | string | undefined | null, currency = 'USD'): string {
  const n = Number(value)
  if (!value || Number.isNaN(n) || n === 0) return ''
  try {
    return new Intl.NumberFormat(undefined, { style: 'currency', currency }).format(n)
  } catch {
    return `$${n.toFixed(2)}`
  }
}
